import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {requestUploadJDFiles} from "@app/services/JobService";
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {alertMessage, Messages} from "@app/constants/Messages";

const UploadJDFilesModal = (props) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [job, setJob] = useState({});
    const [uploading, setUploading] = useState(false);

    const {isShow, onClose, jobInput} = props

    const onSelectFiles = (event) => {
        setSelectedFiles(Array.from(event.target.files));
    };

    useEffect(async () => {
        if (jobInput && jobInput.id) {
            if (!jobInput.input_job_descriptions) {
                jobInput.input_job_descriptions = []
            }
            setJob({...jobInput})
        }
    }, [jobInput]);

    const uploadJDFiles = async () => {
        if (selectedFiles.length > 0) {
            setUploading(true)
            // const requestBody = {job_id: job.id, files: selectedFiles}
            const data = new FormData();
            data.append('job_id', job.id || '')
            data.append('employer_id', job.employer_id || '')
            selectedFiles.forEach(file => {
                data.append('files', file, file.name);
            })

            const res = await requestUploadJDFiles(data)
            setUploading(false)
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(Messages.saveInfoSuccess)
                const resContent = res.content
                if (!job.input_job_descriptions) {
                    job.input_job_descriptions = []
                }
                job.input_job_descriptions = [...job.input_job_descriptions, ...resContent.input_job_descriptions]
                job.id = resContent.job_id
                onClose(true, {...job})
            } else {
                alertMessage(res.sts_code, true, true)
            }
        }
        return ""
    }
    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Upload JD files</Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title'>Choose files</h3>
                        </div>
                        <div className='card-body'>
                            <form encType='multipart/form-data'>
                                <div className='form-group'>
                                    <div className='custom-file'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            id='customFile'
                                            name='files'
                                            multiple
                                            onChange={(event) => onSelectFiles(event)}
                                        />
                                        <label
                                            className='custom-file-label'
                                            htmlFor='customFile'
                                        >
                                            {/* {selectedFiles[0]} */}
                                            {selectedFiles.map((item) => {
                                                return `${item.name}; `;
                                            })}
                                        </label>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type='submit'
                        className='btn btn-primary'
                        onClick={() => uploadJDFiles()}
                        disabled={uploading}
                        data-toggle='modal' data-target='#inputCommonModal'
                    >
                        {uploading ? 'Uploading' : 'Upload'}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UploadJDFilesModal;
